import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ValidateErrorComponent} from './validate-error/validate-error.component';
import {NotificationComponent} from './notification/notification.component';
import {HelpInformationComponent} from './help-information/help-information.component';
import {ImageCropComponent} from './image-crop/image-crop.component';
import {ProfileIconComponent} from './profile-icon/profile-icon.component';
import {TabGroupComponent} from './tab-group/tab-group.component';
import {TabComponent} from './tab-group/tab/tab.component';
import {TermOfServiceComponent} from './term-of-service/term-of-service.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ObserversModule} from '@angular/cdk/observers';
import {DialogComponent} from '../service-parts/dialog/dialog.component';
import {DialogContentDirective} from '../service-parts/dialog/dialog-content.directive';
import {CheckboxModule} from './checkbox/checkbox.module';
import {TeamSelecterComponent} from './team-selecter/team-selecter.component';
import {ImageCropperComponent} from 'ngx-image-cropper';
import 'hammerjs';
import {HammerModule} from '@angular/platform-browser';
import {MoshicomAccountComponent} from './moshicom-account/moshicom-account.component';

@NgModule({
  declarations: [
    ValidateErrorComponent,
    NotificationComponent,
    HelpInformationComponent,
    ImageCropComponent,
    ProfileIconComponent,
    TabGroupComponent,
    TabComponent,
    DialogComponent,
    DialogContentDirective,
    TermOfServiceComponent,
    TeamSelecterComponent,
    MoshicomAccountComponent,
  ],
  imports: [
    CommonModule,
    ObserversModule,
    FormsModule,
    ReactiveFormsModule,
    CheckboxModule,
    ImageCropperComponent,
    HammerModule
  ],
  exports: [
    ValidateErrorComponent,
    NotificationComponent,
    HelpInformationComponent,
    ImageCropComponent,
    ProfileIconComponent,
    TabGroupComponent,
    TabComponent,
    DialogContentDirective,
  ]
})
export class SharedModule {
}
